"use client"

import { useEffect, useState } from "react"
import { Button } from "@/components/ui/button"
import { X } from "lucide-react"
import { motion, AnimatePresence } from "framer-motion"

const STORAGE_KEY = "nudge"

export default function Nudge({open, setOpen}: {open: boolean, setOpen: (a: boolean)=>void}) {
    useEffect(() => {
        const consent = localStorage.getItem(STORAGE_KEY)
        if (!consent) {
            setOpen(true)
        }
    }, [])

    function handleChoice() {
        localStorage.setItem(STORAGE_KEY, "true")
        setOpen(false)
    }

    return (
        <AnimatePresence>
            {open && (
                <motion.div
                    initial={{ opacity: 0, y: 20, scale: 0.95 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    exit={{ opacity: 0, y: 20, scale: 0.95 }}
                    transition={{ duration: 0.25 }}
                    className="fixed bottom-24 right-12 z-50"
                >
                    <div className="relative max-w-xs rounded-2xl border bg-background shadow-xl p-4">

                        <button
                            onClick={() => handleChoice()}
                            className="absolute right-2 top-2 text-muted-foreground hover:text-foreground"
                        >
                            <X size={16} />
                        </button>

                        <p className="text-sm pr-6">
                            Try our new inaccessibility settings the EU forced us to implement.
                        </p>



                        <div className="absolute -bottom-6 right-8 h-4 w-4 rotate-45 border-r border-b bg-background" />
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    )
}